import HierarchicalChildCheckbox, {parentReference} from "./hierarchical-child-checkbox";


export default class HierarchicalCheckbox {

    constructor(element) {
        this.element = element;
        this.id = element.getAttribute('id');
        const selector = "[" + parentReference + "='" + this.id + "']";
        this.children = Array.prototype.slice.call(element.parentNode.querySelectorAll(selector))
            .map(el => new HierarchicalChildCheckbox(el));
    }

    init() {
        this.setListener();
    }

    change() {
        if(this.element.checked) {
            this.children.forEach(child => child.check())
        }
    }

    setListener() {
        $(this.element)
            .on("change", '', $.proxy(this, 'change'))
    }
}
